/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_Merge_Replace_LabelInputs */

const en_marker_import_merge_replace_label = /** @type {(inputs: Marker_Import_Merge_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge/Replace Events`)
};

const fr_marker_import_merge_replace_label = /** @type {(inputs: Marker_Import_Merge_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionner/Remplacer les evenements`)
};

const de_marker_import_merge_replace_label = /** @type {(inputs: Marker_Import_Merge_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenführen/Ersetzen von Ereignissen`)
};

const it_marker_import_merge_replace_label = /** @type {(inputs: Marker_Import_Merge_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisci/Sostituisci eventi`)
};

const ru_marker_import_merge_replace_label = /** @type {(inputs: Marker_Import_Merge_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объединение/замена событий`)
};

const es_marker_import_merge_replace_label = /** @type {(inputs: Marker_Import_Merge_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionar/Reemplazar eventos`)
};

const zh_cn2_marker_import_merge_replace_label = /** @type {(inputs: Marker_Import_Merge_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并/替换事件`)
};

const ja_marker_import_merge_replace_label = /** @type {(inputs: Marker_Import_Merge_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントの結合/置換`)
};

const hi_marker_import_merge_replace_label = /** @type {(inputs: Marker_Import_Merge_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटनाओं को मर्ज/प्रतिस्थापित करें`)
};

const pt_pt2_marker_import_merge_replace_label = /** @type {(inputs: Marker_Import_Merge_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesclar/Substituir Eventos`)
};

/**
* | output |
* | --- |
* | "Merge/Replace Events" |
*
* @param {Marker_Import_Merge_Replace_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_merge_replace_label = /** @type {((inputs?: Marker_Import_Merge_Replace_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Merge_Replace_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_import_merge_replace_label(inputs)
	if (locale === "de") return de_marker_import_merge_replace_label(inputs)
	if (locale === "it") return it_marker_import_merge_replace_label(inputs)
	if (locale === "ru") return ru_marker_import_merge_replace_label(inputs)
	if (locale === "es") return es_marker_import_merge_replace_label(inputs)
	if (locale === "zh-CN") return zh_cn2_marker_import_merge_replace_label(inputs)
	if (locale === "ja") return ja_marker_import_merge_replace_label(inputs)
	if (locale === "hi") return hi_marker_import_merge_replace_label(inputs)
	if (locale === "pt-PT") return pt_pt2_marker_import_merge_replace_label(inputs)
	return en_marker_import_merge_replace_label(inputs)
});